export const DRIVERS_IMPORT_TEMPLATE_PATH =
  '/samples/drivers-import-template.csv';
export const DRIVERS_IMPORT_TEMPLATE_FILENAME =
  'drivers-import-template.csv';
